module.exports = __webpack_public_path__ + "img/broadcast.008414a4.svg";